import * as $ from 'jquery';
import { $id } from '../../services/jquery-utils';
import { removeError, updateErrorView } from './errors/errors';
import { getWidgetForm } from './models/form';
import { anyFlightNumSelected } from './stopover';
import { BookingMode, currentMode, returnMode } from './storage';

export function changeMode() {
    updateModesView(false);
    updateModesView(true);
}

export function updateModesView(isReturn: boolean): void {
    const suffix = isReturn ? 'Return' : '';
    const form = getWidgetForm();

    const noFlight = form.noFlightCheck.prop('checked');
    const $disabled = $id('flight-disabled');
    const $enabled = $id('flight-enabled');

    if (noFlight) {
        $disabled.show();
        $enabled.hide();
    } else {
        $disabled.hide();
        $enabled.show();
    }

    const $flightForm = $id(`form-flight${suffix}`),
        $noflightForm = $id(`form-noflight${suffix}`);

    const flight = {
        left: $flightForm.find(`#flight-left${suffix}`),
        middle: $flightForm.find(`#flight-middle${suffix}`),
        right: $flightForm.find(`#flight-right${suffix}`)
    };

    // Remove errors
    if (!noFlight) {
        removeError(form.row1.noflight.datetime);
        removeError(form.row2.noflight.datetime);
    }

    $('#beginTekst').toggleClass('flight', !noFlight);
    $id('modeSelects').toggleClass('shown', !noFlight);

    // Flight selection
    if (anyFlightNumSelected(isReturn)) {
        const $stopover = $id(`stopover-container${suffix}`);

        if (noFlight || isReturn && !returnMode.value) {
            $stopover.slideUp();
        } else {
            $stopover.slideDown();
        }
    }

    // Show flight/noflight form
    if (noFlight) {
        $flightForm.hide();
        $noflightForm.show();
    } else {
        $flightForm.show();
        $noflightForm.hide();
    }

    // Change shown fields
    function setSize($el: JQuery, size: number): void {
        $el.removeClass().addClass(`size-${size}`);
    }

    switch (currentMode.value) {
        case BookingMode.DoorToDoor:
            setSize(flight.left, isReturn ? 2 : 1);
            setSize(flight.right, isReturn ? 0 : 1);
            break;
        case BookingMode.ToAirport:
            setSize(flight.left, 2);
            setSize(flight.right, 0);
            break;
        case BookingMode.FromAirport:
            setSize(flight.left, isReturn ? 2 : 0);
            setSize(flight.right, isReturn ? 0 : 2);
            break;
        default:
            throw new Error('Unknown mode');
    }

    updateErrorView();
}

export function loadModeSwitcher(): void {
    const form = getWidgetForm();

    form.noFlightCheck.change(() => {
        updateModesView(true);
        updateModesView(false);
    });

    // BookingMode selection buttons
    $id('modeSelects').find('button').on('click', function () {
        const selectedID = this.id;

        let selectedMode: BookingMode | null = null;
        switch (selectedID) {
            case 'mode1':
                selectedMode = BookingMode.DoorToDoor;
                break;
            case 'mode2':
                selectedMode = BookingMode.ToAirport;
                break;
            case 'mode3':
                selectedMode = BookingMode.FromAirport;
                break;
            default:
                throw new Error(`Unknown booking mode '${selectedID}'!`);
        }

        if (selectedMode !== currentMode.value) {
            if (selectedMode === null) {
                throw new Error('Selected mode is null');
            }

            currentMode.value = selectedMode;

            $id('modeSelects').find('button').removeClass('geselecteerd');
            $(this).addClass('geselecteerd');

            form.setBookingMode(currentMode.value);
            changeMode();
            updateErrorView();
        }
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/assets/scripts/modules/widget-core/mode-switcher.ts